import { OpportunityEffects } from './opportunity.effects';

export const OPPORTUNITY_EFFECTS = [OpportunityEffects];
